import { useEffect, useRef, useState } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';

/**
 * Señal de carga GLOBAL para recargas posteriores a la inicial: barra delgada arriba +
 * pastilla con spinner, visible mientras haya fetches en vuelo (cambio de empresa/período,
 * scope, drill-down, …). No bloquea: el tablero sigue interactivo.
 *
 * La carga INICIAL la cubre `DashboardLoadingOverlay` (overlay completo). Aquí latcheamos
 * `initialDone` con la misma lógica para no solaparnos: la barra recién se activa tras el
 * primer asentamiento de fetches. Un debounce de 120ms evita parpadeos en datos cacheados.
 */
export function GlobalLoadingBar() {
  const fetching = useIsFetching();
  const [initialDone, setInitialDone] = useState(false);
  const started = useRef(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (fetching > 0) started.current = true;
    if (started.current && fetching === 0) setInitialDone(true);
  }, [fetching]);

  useEffect(() => {
    if (!initialDone) return;
    if (fetching > 0) {
      const t = setTimeout(() => setVisible(true), 120);
      return () => clearTimeout(t);
    }
    setVisible(false);
  }, [fetching, initialDone]);

  if (!visible) return null;

  return (
    <>
      <div className="fixed inset-x-0 top-0 z-[70] h-[3px] overflow-hidden bg-red-100">
        <div className="h-full w-1/4 bg-gradient-to-r from-transparent via-red-600 to-transparent [animation:loadbar_1.1s_ease-in-out_infinite]" />
      </div>
      <div className="fixed left-1/2 top-2 z-[70] flex -translate-x-1/2 items-center gap-2 rounded-full bg-white/95 px-3 py-1 text-xs font-semibold text-slate-600 shadow-md ring-1 ring-slate-200">
        <Loader2 className="h-3.5 w-3.5 animate-spin text-red-600" />
        Cargando…
      </div>
    </>
  );
}
